<ng-container *ngIf="isAirportAssistanceOption && (contentairportAssistance$ | async)">
  <accordion class="accordion-container">
    <accordion-group class="accordion" [isOpen]="expandExtras === extrasTypesEnum.MedicalAssistance">
      <div accordion-heading class="heading-accordion">
        <img
          *ngIf="airportAssistanceContent?.airportAssistanceIcon"
          [src]="airportAssistanceContent.airportAssistanceIcon.url"
          [alt]="airportAssistanceContent.airportAssistanceIcon.title"
          class="ml-2 mr-3"
        />
        <span class="accordion-title font-weight-bold mt-1">{{ airportAssistanceContent?.airportAssistanceTitle }}</span>
        <ng-content select="[header-extra-content]"></ng-content>
      </div>
      <form>
        <div>
          <accordion class="sub-accordion-container" *ngFor="let passenger of extrasInfo.passengers; let passengerIndex = index">
            <app-accordion-custom
              *ngIf="passenger.passengerDetails?.passengerType !== passengerType.Infant"
              [isExpanded]="true"
              [showDivider]="false"
            >
              <div accordion-title class="sub-heading-accordion">
                <div class="passenger-data">
                  <img
                    *ngIf="airportAssistanceContent?.airportAssistancePassengerIcon"
                    [src]="airportAssistanceContent?.airportAssistancePassengerIcon?.url"
                    [alt]="airportAssistanceContent?.airportAssistancePassengerIcon?.title"
                  />
                  <div class="name">{{ passenger?.passengerDetails?.firstName + ' ' + passenger?.passengerDetails?.lastName }}</div>
                  <div class="dob">{{ passenger?.passengerDetails?.dateOfBirth | formatDate }}</div>
                </div>
                <ng-content select="[extra-content]"></ng-content>
              </div>
              <div accordion-content class="accordion-content" [ngClass]="{ 'loading-state': loading }">
                <label class="assistance-title">{{ airportAssistanceContent?.airportAssistanceSelect }}</label>
                <p class="assistance-subtext">{{ airportAssistanceContent?.airportAssistanceCostless }}</p>
                <div class="accordion-subcontent">
                  <div *ngFor="let assistanceOption of passenger?.passengerExtras[2]?.options; let assistanceIndex = index">
                    <div class="airport-assistance-description">
                      <div class="loading-spinner">
                        <span
                          *ngIf="loading && loadingIndex === passengerIndex && assistanceIndex === loadingProductIndex"
                          class="mdi mdi-loading mdi-spin text-primary"
                        ></span>
                      </div>
                      <div class="custom-control custom-checkbox mt-3">
                        <input
                          type="checkbox"
                          class="custom-control-input cursor-pointer"
                          [ngClass]="{ 'custom-control-input-loading': loading }"
                          [id]="'passenger' + passengerIndex + assistanceOption.displayText"
                          [value]="assistanceOption.isSelected"
                          [checked]="assistanceOption.isSelected"
                          (click)="
                            selectAirportAssistance(assistanceOption, passenger.passengerIdentifier, passengerIndex, assistanceIndex)
                          "
                        />

                        <label
                          class="custom-control-label font-weight-normal cursor-pointer"
                          [for]="'passenger' + passengerIndex + assistanceOption.displayText"
                        >
                          <div class="text-dark" [innerHTML]="assistanceOption?.displayText"></div>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </app-accordion-custom>
          </accordion>
        </div>
      </form>
      <div *ngIf="showSummarize" class="summarize-block">{{ summarizeAirportAssitanceSelction() }}</div>
    </accordion-group>
  </accordion>
</ng-container>
